export const EXPIRY_INTERVAL_TRASH_DAYS = 30
export const EXPIRY_INTERVAL_COMPLETE_DAYS = 14

export const REPEAT_CHECK_INTERVAL_MS = 600000
export const EXPIRY_CHECK_INTERVAL_MS = 600000

export const OBSERVER_DEBOUNCE_INTERVAL = 1000
